import React, { Component, Fragment } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import cx from 'classnames';
import { connect } from 'react-redux';
import { PRODUCT_TAG_REJECT_TYPE_TEXT } from '../../../constants/service/app/productConstants';
import { CONFIRM_TAG_LIST_TYPE, CONFIRM_TAG_LIST_TYPE_TEXT } from '../../../constants/service/app/tagConstants';
import { asyncSimpleModal } from '../../../lib/common';
import { formRequiredRules } from '../../../lib/formRules';
import { appActions } from '../../../store/modules/app';
import Button from '../../Button';
import BaseForm from '../../form/BaseForm';
import SelectForm from '../../form/SelectForm';
import Anchor from '../../link/Anchor';
import Tag from '../Tag/Tag';
import './ConfirmTag.scss';

class ConfirmTag extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tagSelectVisible: false,
    };
  }

  /**
   *  태그 선택 SELECT 리스트 토글
   */
  showTagSelectVisible = () => {
    const { tagSelectVisible } = this.state;

    this.setState({
      tagSelectVisible: !tagSelectVisible,
    });

    /**
     *  태그 추가 버튼을 클릭 시
     *  자동으로 Select box 에 focus 가 되도록 함.
     */
    if (!tagSelectVisible) {
      this.selectRef.focus();
    } else {
      this.selectRef.blur();
    }
  };

  /**
   *  태그 버튼 타입 변경
   */
  onChangeConfirmTagButtonType = (type) => {
    const { setData, targetPath, isEditable } = this.props;

    if (!isEditable) {
      return;
    }

    setData({
      path: [...targetPath, 'confirmTagButtonType'],
      value: type,
    });
  };

  /**
   *  태그 선택/해제 callback
   */
  onChangeTag = (data) => {
    const { form, name, setData, targetPath, tagList, confirmTagData, onChangeTagList } = this.props;
    const { confirmTagButtonType } = confirmTagData;

    if (confirmTagButtonType !== CONFIRM_TAG_LIST_TYPE.ACTIVE) return;

    const { action, id } = data;
    let updatedSelectedTagList = [];

    /**
     *  태그 추가
     */
    if (action === 'add') {
      const targetTag = tagList.find((item) => item.id === id);
      updatedSelectedTagList = [...confirmTagData[CONFIRM_TAG_LIST_TYPE.ACTIVE], targetTag];
    } else {
      /**
       *  태그 해제
       */
      updatedSelectedTagList = confirmTagData[CONFIRM_TAG_LIST_TYPE.ACTIVE].filter((item) => item.id !== id);
    }

    setData({
      path: [...targetPath, CONFIRM_TAG_LIST_TYPE.ACTIVE],
      value: updatedSelectedTagList,
    });

    onChangeTagList && onChangeTagList(updatedSelectedTagList);

    /**
     *  데이터가 변경될 때마다, 해당 form value 도 변경해야 함.
     */
    const updatedSelectedTagIdList = updatedSelectedTagList.map((item) => item.id);
    form.setFieldsValue({ [name]: updatedSelectedTagIdList });
    form.validateFields([name]);
  };

  /**
   *  태그 승인하기
   */
  permitRegistrationTag = async () => {
    const { tagGroupType, permitRegistrationTag, confirmTagData } = this.props;
    const tagGroupId = confirmTagData[CONFIRM_TAG_LIST_TYPE.CONFIRM_READY][0].groupId;
    const tagList = confirmTagData[CONFIRM_TAG_LIST_TYPE.CONFIRM_READY].isDelete
      ? []
      : confirmTagData[CONFIRM_TAG_LIST_TYPE.CONFIRM_READY];
    const tagNameList = tagList.map((item) => item.name).join(',');

    const message = confirmTagData[CONFIRM_TAG_LIST_TYPE.CONFIRM_READY].isDelete
      ? '노출중인 태그 삭제 요청을 승인하시겠습니까 ?'
      : `${tagNameList} 를 승인하시겠습니까?`;

    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '태그 승인',
      message,
    });

    if (!confirmResult) return;

    permitRegistrationTag({
      tagGroupType,
      tagGroupId,
      tagList,
    });
  };

  /**
   *  태그 거절하기
   */
  rejectRegistrationTag = async () => {
    const { tagGroupType, rejectRegistrationTag, confirmTagData } = this.props;
    const tagGroupId = confirmTagData[CONFIRM_TAG_LIST_TYPE.CONFIRM_READY][0].groupId;
    const tagList = confirmTagData[CONFIRM_TAG_LIST_TYPE.CONFIRM_READY];
    const tagNameList = tagList.map((item) => item.name).join(',');

    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '태그 거절',
      message: `${tagNameList} 를 거절하시겠습니까?`,
    });

    if (!confirmResult) return;

    rejectRegistrationTag({
      tagGroupType,
      tagGroupId,
    });
  };

  render() {
    const {
      className,
      label,
      form,
      required,
      name,
      isEditable,
      checkTagName,
      maxCnt,
      confirmTagData,
      tagList = [],
      isIndividualInspection,
      subContent,
      isCompare,
    } = this.props;
    const { tagSelectVisible } = this.state;
    const { confirmTagButtonType } = confirmTagData;

    return (
      <BaseForm
        className={cx('confirm-tag', className)}
        label={label}
        required={required}
        content={
          <Fragment>
            {!isCompare &&
            (confirmTagData[CONFIRM_TAG_LIST_TYPE.CONFIRM_READY].length ||
              confirmTagData[CONFIRM_TAG_LIST_TYPE.REJECT].length) ? (
              <div className="confirm-tag-button-type-list">
                {
                  <Fragment>
                    {/* 노출 중인 태그 */}
                    <Button
                      className="confirm-tag-type-button"
                      color={CONFIRM_TAG_LIST_TYPE.ACTIVE === confirmTagButtonType ? 'primary' : 'light'}
                      onClick={() => this.onChangeConfirmTagButtonType(CONFIRM_TAG_LIST_TYPE.ACTIVE)}
                      text={CONFIRM_TAG_LIST_TYPE_TEXT[CONFIRM_TAG_LIST_TYPE.ACTIVE]}
                    />

                    {/* 검수 요청 중인 태그 */}
                    {confirmTagData[CONFIRM_TAG_LIST_TYPE.CONFIRM_READY].length ? (
                      <Button
                        className="confirm-tag-type-button"
                        color={CONFIRM_TAG_LIST_TYPE.CONFIRM_READY === confirmTagButtonType ? 'primary' : 'light'}
                        onClick={() => this.onChangeConfirmTagButtonType(CONFIRM_TAG_LIST_TYPE.CONFIRM_READY)}
                        text={CONFIRM_TAG_LIST_TYPE_TEXT[CONFIRM_TAG_LIST_TYPE.CONFIRM_READY]}
                      />
                    ) : null}

                    {/* 승인 거절된 태그 */}
                    {confirmTagData[CONFIRM_TAG_LIST_TYPE.REJECT].length ? (
                      <Button
                        className="confirm-tag-type-button"
                        color={CONFIRM_TAG_LIST_TYPE.REJECT === confirmTagButtonType ? 'primary' : 'gray'}
                        onClick={() => this.onChangeConfirmTagButtonType(CONFIRM_TAG_LIST_TYPE.REJECT)}
                        text={CONFIRM_TAG_LIST_TYPE_TEXT[CONFIRM_TAG_LIST_TYPE.REJECT]}
                      />
                    ) : null}
                  </Fragment>
                }
              </div>
            ) : null}

            <div className="tag-list">
              {confirmTagData[confirmTagButtonType].map((tag) => (
                <Tag
                  className={cx({ inactive: tag.inActive })}
                  key={tag.id}
                  text={tag.name}
                  isShowToolTip={tag.inActive}
                  onClick={() => tag.inActive && checkTagName(tag.name)}
                  onClose={() =>
                    this.onChangeTag({
                      action: 'remove',
                      id: tag.id,
                    })
                  }
                  closable={isEditable && confirmTagButtonType === CONFIRM_TAG_LIST_TYPE.ACTIVE}
                />
              ))}

              {confirmTagData[confirmTagButtonType].isDelete ? (
                <div className="request-active-tag-delete">*노출중인 태그를 삭제 요청중입니다</div>
              ) : null}
            </div>

            {isEditable &&
            confirmTagButtonType === CONFIRM_TAG_LIST_TYPE.CONFIRM_READY &&
            confirmTagData[CONFIRM_TAG_LIST_TYPE.CONFIRM_READY].length &&
            !isIndividualInspection ? (
              <div className="confirm-tag-button-list">
                <Button
                  className="confirm-tag-button"
                  color="primary"
                  onClick={this.permitRegistrationTag}
                  text="승인하기"
                />

                <Button
                  className="confirm-tag-button"
                  color="light"
                  onClick={this.rejectRegistrationTag}
                  text="거절하기"
                />
              </div>
            ) : null}

            {confirmTagButtonType === CONFIRM_TAG_LIST_TYPE.REJECT &&
            confirmTagData[CONFIRM_TAG_LIST_TYPE.REJECT].length ? (
              <div className="rejected-tag-info">
                <span className="rejected-tag-type">거절 사유: </span>
                <Anchor
                  color="primary"
                  isUnderLine
                  onClick={async () =>
                    await asyncSimpleModal({
                      title: '거절 사유',
                      message: confirmTagData.rejectInfo.reason,
                    })
                  }
                  text={PRODUCT_TAG_REJECT_TYPE_TEXT[confirmTagData.rejectInfo.type]}
                />
              </div>
            ) : null}

            {isEditable && confirmTagButtonType === CONFIRM_TAG_LIST_TYPE.ACTIVE ? (
              <Fragment>
                <div className={cx('add-tag-button', { hide: tagSelectVisible })} onClick={this.showTagSelectVisible}>
                  <PlusOutlined /> 태그 추가
                </div>

                <SelectForm
                  className="tag-input"
                  form={form}
                  name={name}
                  isTable={true}
                  rules={[
                    formRequiredRules(required, null, false),
                    {
                      validator: (rule, value, cb) => {
                        if (maxCnt && value.length > maxCnt) {
                          cb(`해당 태그 분류에서는 태그를 최대 ${maxCnt}개까지만 등록할 수 있습니다.`);
                        } else cb();
                      },
                    },
                  ]}
                  showSearch
                  optionFilterProp="children"
                  list={tagList}
                  mode="multiple"
                  initialValue={confirmTagData[CONFIRM_TAG_LIST_TYPE.ACTIVE].map((item) => item.id)}
                  onSelect={(id) =>
                    this.onChangeTag({
                      action: 'add',
                      id,
                    })
                  }
                  onDeselect={(id) =>
                    this.onChangeTag({
                      action: 'remove',
                      id,
                    })
                  }
                  showAction={['click', 'focus']}
                  setRef={(input) => (this.selectRef = input)}
                  onBlur={this.showTagSelectVisible}
                  subContent={subContent}
                  // onInputKeyDown={(e) => {
                  //     /**
                  //      *  기존에 존재하지 않는 태그를 입력한 경우
                  //      */
                  //     if (e.keyCode === 13 && e.target.value.length) {
                  //         this.onChange({
                  //             action: "add",
                  //             value: e.target.value
                  //         });
                  //     }
                  //     /**
                  //      *  백 스페이스를 입력하고 입력한 텍스트가 없는 경우
                  //      */
                  //     else if (e.keyCode === 8 && !e.target.value) {
                  //         this.onChange({});
                  //     }
                  // }}
                />
              </Fragment>
            ) : null}

            {!isEditable &&
            confirmTagButtonType === CONFIRM_TAG_LIST_TYPE.ACTIVE &&
            !confirmTagData[CONFIRM_TAG_LIST_TYPE.ACTIVE].length ? (
              <div className="nothing-confirm-ready-tag-list">노출 중인 태그가 없습니다.</div>
            ) : null}
          </Fragment>
        }
      />
    );
  }
}

const mapDispatchToProps = {
  checkTagName: appActions.checkTagName,
};

export default connect(null, mapDispatchToProps)(ConfirmTag);
